var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDashboardGeneratorSelected = function SvgIconDashboardGeneratorSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3F94FF",
    strokeMiterlimit: 10,
    strokeWidth: 0.7,
    d: "M15.876.621H4.821a3.567 3.567 0 0 0-3.567 3.567v11.055A3.567 3.567 0 0 0 4.82 18.81h11.055a3.567 3.567 0 0 0 3.567-3.567V4.188A3.567 3.567 0 0 0 15.876.62Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3F94FF",
    d: "m17.71 14.864-3-5.823c-.222-.422-.756-.422-.978 0l-1.744 3.367c-.067.122-.222.122-.289 0L8.577 6.364c-.3-.59-1.056-.59-1.367 0l-4.189 8.133c-.3.589.078 1.322.678 1.322h13.522c.433 0 .7-.522.49-.944zM12.32 7.319a1.156 1.156 0 1 0 0-2.311 1.156 1.156 0 0 0 0 2.31"
  })));
};
export default SvgIconDashboardGeneratorSelected;